import {
  LetterbooksPromptConditionType,
} from "features/Letterbooks/types";
import { LetterbooksParentPromptContextType } from "types/LetterbooksParentContextType";

export default function promptConditions(
  context: LetterbooksParentPromptContextType
): LetterbooksPromptConditionType {
  const { prompt } = context;

  return {
    prompt_id: prompt.id,
  };
}
